import JoditEditor from 'jodit-react';

type JoditEditorWrapperProps = {
  id?: string;
  value: string;
  config?: Record<string, unknown>;
  onBlur?: (newContent: string) => void;
  onChange?: (newContent: string) => void;
};

export const JoditEditorWrapper = (props: JoditEditorWrapperProps) => {
  return <JoditEditor {...props} />;
};
